import {InitPage} from "../../index";
import { ElcPlanningCalendar } from "../planning_calendar";
import {ScrollPage} from "../../common/scroll_page";

declare var $;
declare var calendarState;
declare var allCellDataPath;
declare var calendarDate;

export class ElcProductionCalendar extends ElcPlanningCalendar {
    loadEditProduction(el) {
        const editUrl = $(el).data("edit-url");
        window.location.replace(editUrl);
    }
}


export function LoadPage() {
    InitPage("elc productions calendar", () => {
        if ($(".elc-production-calendar").length > 0) {
            window.ProductionCalendar = new ElcProductionCalendar();
            window.ProductionCalendar.initCells();
            // window.ProductionCalendar.hideEmptyRows();
            // const sp = new ScrollPage();
        }
    });
}
